import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('PasswordReminderController', PasswordReminderController);

    /** @ngInject */
    function PasswordReminderController(AuthFactory, $scope, $state, toastr) {
        var vm = this;

        vm.sendNewPassword = function () {
            var data = {
                email: vm.email,
            };

            AuthFactory.authPasswordReset(data)
                .success(function () {
                    toastr.success(
                        'Wysłaliśmy do Ciebie wiadomość e-mail. Sprawdź skrzynkę pocztową.'
                    );
                    $state.go('login');
                })
                .error(function (response) {
                    for (var key in response) {
                        var value = response[key];

                        if ($scope.loginForm && key != 'non_field_errors') {
                            $scope.loginForm[key].$setValidity(
                                'error_field',
                                true
                            );
                        }

                        value.forEach(function (element, index, array) {
                            toastr.error(value[index]);
                        });
                    }
                });
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/password_reminder/password_reminder.controller.ts